export default __webpack_public_path__ + "static/space-instructions-57067f3fce103292d899159906d86c88.png";